import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocationFieldsService {

  //Behavior Subject for Category
  private category = new BehaviorSubject('');

  getCategory(): Observable<any> {
    return this.category.asObservable();
  }

  setCategory(cat) {
    this.category.next(cat);
  }

  constructor(private http: HttpClient) { }

  deleteField(id) {
    return this.http.delete<any>(`${environment.inventoryURl}Category/${id}`)
      .toPromise()
      .then(res => res);
  }

  addCategory(data) {
    return this.http.post<any>(`${environment.inventoryURl}Category`, data)
      .toPromise()
      .then(res => res);
  }

  updateCategory(data) {
    return this.http.put<any>(`${environment.inventoryURl}Category`, data)
      .toPromise()
  }

  getCategoryLocation(id) {
    return this.http.get<any>(`${environment.inventoryURl}Category/CheckWarehouseCategoryAssociation?id=${id}`);
  }
}
